import classNames from 'classnames';
import { forwardRef } from 'react';

import { VideoProps } from './video.types';

export const Video: React.FC<VideoProps> = forwardRef<
  HTMLVideoElement,
  VideoProps
>(({ src, className, videoClassName, ...rest }, ref) => {
  const containerClass = classNames('video', className);
  const videoClasses = classNames('video-player', videoClassName);

  return (
    <div className={containerClass}>
      <video className={videoClasses} playsInline autoPlay ref={ref} {...rest}>
        <source src={src} />
      </video>
    </div>
  );
});

Video.displayName = 'VideoPlayer';

export default Video;
